<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  name: "ApprovalModal",
  data() {
    return {};
  },
  computed: {
    show: {
      set(value) {
        this.$store.commit(`${this.currentType}/approvalOpened`, value);
      },
      get() {
        return this.approvalOpened;
      },
    },
    activityCurrentTab() {
      return this.$store.getters[`${this.currentType}/activityCurrentTab`];
    },
    approvalStatus() {
      return this.$store.getters[`${this.currentType}/approvalStatus`];
    },
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    approvalOpened() {
      return this.$store.getters[`${this.currentType}/approvalOpened`];
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        } else if (
          url == "update-workout" ||
          this.$route.path == "/create-workout"
        ) {
          return "workouts";
        }
      }
      return "commons";
    },
  },
  methods: {
    updateActivity(status) {
      this.$store.commit(`${this.currentType}/setActivityStatus`, status);
      this.$store
        .dispatch(`${this.currentType}/updateActivity`, this.currentActivity.id)
        .then(
          (res) => {
            // this.makeToast("success", "Success", `Succesfully saved.`);
            if (this.activityCurrentTab == 6) {
              this.updateProduction();
            } else {
              this.$store.commit(`commons/setSavingForm`, "Saved");
              this.$store.commit(
                `${this.currentType}/setOpenedApproval`,
                false
              );
            }
          },
          (error) => {
            console.log(error);
          }
        );
    },
    updateProduction() {
      this.$store
        .dispatch(`${this.currentType}/updateProduction`, this.$route.params.id)
        .then((res) => {
          this.$store.dispatch(
            `${this.currentType}/updateVideo`,
            this.$route.params.id
          );

          this.$store.commit(`commons/setSavingForm`, "Saved");
          this.$store.commit(`${this.currentType}/setOpenedApproval`, false);
        });
    },
    close() {
      this.$store.commit(`${this.currentType}/setOpenedApproval`, false);
    },
    onHidden(e) {
      this.$store.commit(`${this.currentType}/setOpenedApproval`, false);
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    textStatus(status) {
      console.log(status);
      if (status == "approved") {
        return "Approve & Pause";
      }

      if (status == "published") {
        return "Approve & publish";
      }
    },
  },
};
</script>
<style lang="scss">
.cancel {
  border: 1px solid #e0e1e2 !important;
  background: #e0e1e2 !important;
  color: #00000099 !important;
  &:hover {
    background: #5a6268 !important;
    color: #fff !important;
  }
}
#notesModal {
  .modal-header {
    border: 0;
    text-align: center;
    padding: 0;
    border: 0 !important;
    padding: 0 !important;
    padding-top: 50px !important;
    h2 {
      font-size: 32px;
      margin: 0;
    }
  }

  .modal-body {
    padding: 0 !important;
    .content {
      h3 {
        color: rgba(51, 51, 51, 0.87) !important;
        font-size: 20px !important;
        font-family: "Lato-Regular" !important;
        text-align: center;
        padding: 15px 0 20px;
      }
      p {
        font-size: 16px;
        font-family: "Lato-Regular";
        color: #000000de;
      }
      ul {
        padding: 0;
        li {
          display: inline-block;
          padding: 14px 25px;
          border: 1px solid #dedede;
          border-radius: 4px;
          margin-right: 20px;
          background: #fff;

          &.active {
            border: 1px solid #3f9698;
            background: #effdff;
          }
          img {
            width: 25px;
            height: 25px;
          }
        }
      }

      textarea {
        max-height: 200px;
        min-height: 200px;
      }
    }
  }

  .modal-footer {
    border: 0 !important;
    padding: 0 !important;
    padding-bottom: 50px !important;
  }
}
</style>

<template>
  <b-modal
    @hidden="onHidden"
    v-model="show"
    id="notesModal"
    size="lg"
    :close-on-backdrop="false"
    :close-on-esc="false"
    class="pt-5"
  >
    <template #modal-header>
      <div class="w-100 header px-5 pt-3">
        <h2>Are you sure to {{ textStatus(approvalStatus) }}?</h2>
      </div>
    </template>
    <div class="content px-5 pt-2 pb-5">
      <h3>
        You’re about to make {{ currentActivity.working_title }} visible to the
        app members.
      </h3>
    </div>
    <template #modal-footer>
      <div class="text-center w-100 px-5 pb-3">
        <b-button variant="secondary cancel px-4 py-3" @click="close()"
          >CANCEL</b-button
        >
        <b-button
          variant="primary px-4 py-3 ml-3 text-uppercase"
          @click="updateActivity(approvalStatus)"
        >
          {{ textStatus(approvalStatus) }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>